<template>
  <div class="symbolTag">

    <div class="symbolTagInfo" @click="$emit('symbolClicked')">
      <symbol-link v-if="options?.link" :disablePreview="options?.symbolLinkPreview" :symbol="symbol"/>
      <keep-alive>
        <symbol-logo :small="options.logo === 'small'" v-if="options?.logo && showSymbolActions" :symbol="symbol"/>
      </keep-alive>
      <div class="ticker">{{ symbol }}</div>
    </div>

    <div class="symbolTagActions">
      <span v-if="showSymbolActions" class="symbolTagActions">
      <SymbolTagLabel v-if="tags?.earnings" :data="tags.earnings" :type="'E'"/>
      <SymbolTagLabel v-if="tags?.dividends" :data="tags.dividends" :type="'D'"/>
      <SymbolTagLabel v-if="tags?.split" :data="tags.split" :type="'S'"/>
      <SymbolTagLabel v-if="tags?.trending && !options?.hideTrendingTag" :type="'T'"/>
      </span>


      <symbol-chart :symbol="options?.chartSymbol || symbol" style="z-index: 1" v-if="options?.chart"/>
      <div :dir="uiDirection" class="addRemoveSymbol add fixedSixty"
           @click="addRemoveWatchlistSymbol(symbol)"
           v-if="!watchlist?.watchlist.includes(symbol) && this.options?.watchlist !== false">
        <span>{{ dictionary.buttons.addToPortfolioShort }}</span>
      </div>
      <div :dir="uiDirection" class="addRemoveSymbol remove fixedSixty"
           @click="addRemoveWatchlistSymbol(symbol)"
           v-if="watchlist?.watchlist.includes(symbol)  && this.options?.watchlist !== false">
        <span>{{ dictionary.buttons.removeFromPortfolioShort }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SymbolLink from "./symbolLink";
import SymbolLogo from "./symbolLogo";
import SymbolChart from "./symbolChart";
import UserService from "../../services/user";
import {useWatchlist} from "../../stores/watchlist";
import SymbolTagLabel from "./symbolTagLabel";

export default {
  name: "symbolTag",
  components: {SymbolTagLabel, SymbolChart, SymbolLogo, SymbolLink},
  props: ['options', 'symbol', 'tags', 'showSymbolActions'],
  data() {
    return {
      watchlist: useWatchlist(),
    }
  },
  methods: {
    async addRemoveWatchlistSymbol(symbol) {

      if (this.watchlist.watchlist.includes(symbol)) {

        try {
          mixpanel.track('symbol:remove', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }

        const watchlist = await UserService.removeSymbolFromWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      } else {

        try {
          mixpanel.track('symbol:add', {client: window.location.host, symbol: symbol});
        } catch (e) {
        }
        const watchlist = await UserService.addSymbolToWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/general";

.addRemoveSymbol {
  flex: 0 0 55px !important;
  width: 45px;


  i {
    display: none;
  }

  @media(max-width: 660px) {

    flex: 0 0 30px !important;
    width: 30px;
    height: 20px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    i {
      display: block;
    }

    span {
      //display: none;
    }
  }
}

.symbolTag {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  @media (max-width: 768px) {
    gap: 10px;
  }

  .symbolTagInfo {
    flex: 1 0 auto;
  }

  .ticker {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
    @media (max-width: 768px) {
      max-width: 90px;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .symbolTagInfo, .symbolTagActions {
    position: relative;
    gap: 10px;
    display: flex;
    align-items: center;
    @media (max-width: 768px) {
      gap: 5px;
    }
  }

  a {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
